import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { WhyUsHero } from '../../components/why-us/WhyUsHero';
import { ProblemSection } from '../../components/why-us/ProblemSection';
import { NativeSection } from '../../components/why-us/NativeSection';
import { ExperienceSection } from '../../components/why-us/ExperienceSection';
import { CustomerCareSection } from '../../components/why-us/CustomerCareSection';
import { WhyUsProducts } from '../../components/why-us/WhyUsProducts';
import { FinalCTA } from '../../components/why-us/FinalCTA';
import { SEOBlock } from '../../components/why-us/SEOBlock';
import type { WhyUsLandingProps } from '../../types/whyus-landing';

export default function WhyUs({ featuredProducts, appUrl, loginUrl }: WhyUsLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Por qué elegirnos | Abasto Virtual</title>
        <meta
          name="description"
          content="Somos un ecommerce nativo de frutas y verduras. Stock en tiempo real, seguimiento de pedidos, búsqueda inteligente y atención personalizada."
        />
        <link rel="canonical" href={`${appUrl}/por-que-elegirnos`} />
      </Head>

      <WhyUsHero />
      <ProblemSection />
      <NativeSection />
      <ExperienceSection />
      <CustomerCareSection />
      <WhyUsProducts products={featuredProducts} />
      <FinalCTA loginUrl={loginUrl} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
